/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralCitiesRepository = (options: GeneralRestApiOptions): Types.GeneralCitiesRepository => ({
    async search(params, requestOptions) {
        return options.request('/cities/search', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
});
